import { useTranslation } from "react-i18next";
import { formatMonthShort } from "../../lib/format";
import type { VacancyAnnotation } from "../../lib/realestate";

interface OrphanAnnotationCardProps {
  annotation: VacancyAnnotation;
  onDelete: () => void;
}

export function OrphanAnnotationCard({ annotation, onDelete }: OrphanAnnotationCardProps) {
  const { t } = useTranslation();
  return (
    <div className="bg-amber-50 border border-amber-200 rounded p-3 space-y-1">
      <div className="flex justify-between items-start">
        <div>
          <p className="text-sm font-medium">
            {annotation.unitLabel} · {formatMonthShort(annotation.startMonth)}
          </p>
          <p className="text-xs text-slate-600">
            {t(`realestate.vacancy.reason_${annotation.reason}`)}
            {annotation.notes ? ` — ${annotation.notes}` : ""}
          </p>
        </div>
        <button type="button" className="text-xs text-red-600 underline" onClick={onDelete}>
          {t("realestate.vacancy.delete_annotation")}
        </button>
      </div>
    </div>
  );
}
